import { createContext } from 'react';
import { GraphQLClient } from 'graphql-request';

import { DeviceInformation } from '@hooks/use-element';
import { Db } from '@services/db';
import { KV } from '@services/kv';
import InMemoryKV from '@services/kv/InMemoryKV';
import config from '@config';

const { host, appKey } = config.build;

export const AppContext = createContext<AppContextProps>({
	appKey: '',
	lang: '',
	languages: [],
	onLanguageChange: () => {},
	onlineStatus: true,
	device: null,
	isPrinting: false,
	sw: null,
	isInstalled: false,
	rebuildGraphQLClient: () => {},
	isSupportInstallPrompt: typeof window.onbeforeinstallprompt === 'object',
	showDialog: false,
	setShowDialog: () => {},
	kv: new InMemoryKV(),
	baseUrl: '',
	graphQLClient: new GraphQLClient(`${host}/graphql`, {
		headers: {
			'app-key': appKey,
		},
	}),
	parseGraphQLClientError: () => new Error(''),
});

interface AppContextProps {
	appKey: string;
	lang: string;
	languages: Array<any>;
	onLanguageChange: Function;
	onlineStatus: boolean;
	device: DeviceInformation | null;
	isPrinting: boolean;
	db?: Db;
	isInstalled: boolean;
	sw: ServiceWorker | null;
	rebuildGraphQLClient: () => void;
	isSupportInstallPrompt: boolean;
	deferredPrompt?: any;
	showDialog: boolean;
	setShowDialog: (v: boolean) => void;
	kv: KV;
	baseUrl: string;
	clearCache?: Promise<void>;
	graphQLClient: GraphQLClient;
	parseGraphQLClientError: (err: any) => Error;
}
